import React from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { DataTable } from "../../common/DataTable";

const TrainingTab = ({
    showSnackbar,
    trainingRecords,
    loading,
}) => {
    const columns = [
        { accessorKey: "employee_name", header: "Employee Name" },
        {
            accessorKey: "total_assigned",
            header: "Total",
            cell: ({ getValue }) => <span className="text-center block">{getValue()}</span>,
        },
        {
            id: "completed_count",
            header: "Completed",
            cell: ({ row }) => <span className="text-center block">{row.original.completed_count ?? 0}</span>,
        },
        {
            id: "completed_date",
            header: "Completed Date",
            cell: ({ row }) => (
                <span className="text-center block">
                    {row.original.completed_date ? new Date(row.original.completed_date).toLocaleDateString("en-GB") : "—"}
                </span>
            ),
        },
        {
            accessorKey: "status",
            header: "Status",
            cell: ({ getValue }) => (
                <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${getValue() === "completed" ? "bg-green-100 text-green-800" : "bg-yellow-100 text-yellow-800"}`}>
                    {getValue() === "completed" ? "Completed" : "Pending"}
                </span>
            ),
        },
    ];

    return (
    <div className="space-y-6">
        <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold text-gray-900">Employee Training Progress</h3>
            <button
                onClick={() => showSnackbar("Open Add Training Modal here", "success")}
                className="inline-flex items-center px-4 py-2 border border-transparent rounded-md font-medium text-white transition-opacity hover:opacity-90"
                style={{ backgroundColor: "var(--app-primary-color, #26256b)" }}
            >
                <PlusIcon className="w-5 h-5 mr-2" />
                Add Training
            </button>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-medium text-gray-900">Employee Training Progress</h3>
                <p className="text-sm text-gray-600 mt-1">Track each employee's assigned trainings and completion status.</p>
            </div>

            <DataTable
                columns={columns}
                data={trainingRecords}
                getRowId={(record, index) => String(record.employee_id || index)}
                loading={loading}
                emptyMessage="No training records found."
                enableColumnVisibility={false}
                enableColumnResizing
                maxBodyHeight="65vh"
            />
        </div>
    </div>
    );
};

export default TrainingTab;
